import React from 'react'
import logo from './../../images/logo.png'
import * as styled from './styles'

const Logo = () => {
  return (
    <styled.Logo data-testid="header-icon" src={logo} alt='logo'/>
  )
}

export default Logo